import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>The system cannot authorize this formula because the patient’s BMI, or the quantity requested, is outside of the allowable range. You may need to begin a manual prior approval documenting medical necessity.</p>

				<div className="button" onClick={() => this.props.navigate('R13A')}>For instructions on how to begin a manual Prior Approval request, click here.</div>
			</div>
		);
	}
}